import React from "react";
import {useHistory} from "react-router-dom";
import {apollo_useStyles} from "../../atom/Apollo_styles";
import {
  userdetail_path
} from "../../atom/Apollo_links";
import {PageUser} from "../../pages/USER/UserModel";
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import {Typography, Chip} from "@material-ui/core";
import {ApolloDataTable, STORAGE_KEY} from "../../atom/Apollo_DataTable";
import {MUISortOptions, SelectableRows} from "mui-datatables";
import Card from "@material-ui/core/Card/Card";
import {CsvData, UserColumns} from "../../common/Apollo_CommonConst";

interface UserTopProps {
  children?: React.ReactNode;
  rows: any;
}
const ApolloUserTop = (props: UserTopProps) => {

  const {children, rows, ...other} = props;
  const history = useHistory();
  const classes = apollo_useStyles();
  const [userList, setUserList] = React.useState<PageUser[]>([]);

  React.useEffect(() => {
    const localUsers = rows.map((user:PageUser) => {
      if (user.systemAdminFlg === "1") {
        user.systemAdminFlg = "管理者";
      } else if (user.systemAdminFlg === "2") {
        user.systemAdminFlg = "運用者";
      } else {
        user.systemAdminFlg = "";
      }
      return user
    })
    setUserList(localUsers);
  }, [rows]);

  const userColumns = [
    {
      name: "userId",
      label: "ユーザーID",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "mailaddress",
      label: "メールアドレス",
      options: {
        filter: true,
        sort: false,
      }
    },
    {
      name: "familyName",
      label: "氏名(姓)",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "firstName",
      label: "氏名(名)",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "roleCount",
      label: "所有ロール数",
      options: {
        setCellProps: () => ({
          align: "left"
        }),
        filter: true,
        sort: true,
        customBodyRender: (value: number) => {
          return value? value.toLocaleString() : 0;
        },
      },
    },
    // TODO システム管理・運用
    {
      name: "systemAdminFlg",
      label: " ",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value: string) => {
          const bgcolor = value === "運用者" ? "blue" : value === "管理者" ? "red" : ""
          if (value !== "0") { 
            return (
              <Chip
                label={
                  <Typography variant="subtitle2">{value}</Typography>
                }
                style={
                  { backgroundColor: bgcolor, color: 'white', height: "50%" }
                }
              />
            )
          } else {
            return null
          }
        }
      }
    },
    {
      name: "",
      label: "詳細",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (idx: number) => {
          return (
            <KeyboardArrowRightIcon
              onClick={() => history.push(userdetail_path + rows[idx].userId)}
              className={classes.link}
              style={{cursor: "pointer"}}
            />
          );
        }
      },
    },
  ];

  const userSortOrder: MUISortOptions = {
    name: "userId",
    direction: 'desc',
  }
  const selectableRows: SelectableRows = 'none';
  const userOptions = {
    filter: true,
    downloadOptions: {
      filename: `users.csv`,
      separator: ",",
      filterOptions: {
        useDisplayedColumnsOnly: false,
        useDisplayedRowsOnly: true,
      }
    },
    onDownload: (buildHead: any, buildBody: any, columns: any, data: any) => {
      const csvData = formatCsvData(data, userList);
      return "\uFEFF" + buildHead(UserColumns) + buildBody(csvData);
    },
    print: false,
    sort: true,
    sortOrder: localStorage.getItem(STORAGE_KEY.APOLLO_USER) ? undefined : userSortOrder,
    selectableRows: selectableRows,
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 25, 50],
    jumpToPage: true,
    expandableRows: false,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    storageKey: STORAGE_KEY.APOLLO_USER,
  }

  return (
    <Card className={classes.root} square variant="outlined">
      <ApolloDataTable
        title=""
        data={userList ? userList : []}
        columns={userColumns}
        options={
          {
            ...userOptions,
            textLabels:{
              body: {noMatch: "該当データが存在しません"}
            },
          }
        }
      />
    </Card>
  );
};

const formatCsvData = (data: any[], tableData: PageUser[]): CsvData[] => {
  const dataList: CsvData[] = [];
  console.log(tableData);
  data?.map((v: { index: any, data: any[] }) => {
      if (!v.data || v.data.length === 0) return;
      const values = tableData.filter((td) => td.userId === v.data[0]);
      if (!values || values.length === 0) return;
      const d = values[0];
      const list: CsvData = {
        index: v.index,
        data: [
          d.userId,
          d.mailaddress,
          d.familyName,
          d.firstName,
          d.roleCount,
          d.systemAdminFlg,
        ],
      };
      dataList.push(list);
    }
  );
  return dataList;
}

export default ApolloUserTop;
